/**
 *
 */


class GBIS_Map{

    /**
     *
     * @param options
     */
    constructor(options){

        console.debug('Map : constructor');

        let defaultOptions = {
            containerId: 'mainGmap',
            map_center: 0,
            zoom_level: 10,
            gmap: {
                mapTypeControl: false,
                center: {lat: -25.363, lng: 131.044},
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "all",
                        elementType: "labels.text.fill",
                        stylers: [{
                            saturation: 36
                        }, {
                            color: "#333333"
                        }, {
                            lightness: 40
                        }]
                    }, {
                        featureType: "all",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            visibility: "on"
                        }, {
                            color: "#ffffff"
                        }, {
                            lightness: 16
                        }]
                    }, {
                        featureType: "all",
                        elementType: "labels.icon",
                        stylers: [{
                            visibility: "off"
                        }]
                    }, {
                        featureType: "administrative",
                        elementType: "geometry.fill",
                        stylers: [{
                            color: "#fefefe"
                        }, {
                            lightness: 20
                        }]
                    }, {
                        featureType: "transit",
                        elementType: "geometry",
                        stylers: [{
                            color: "#f2f2f2"
                        }, {
                            lightness: 19
                        }]
                    }, {
                        featureType: "transit.station",
                        elementType: "labels.icon",
                        stylers: [{
                            visibility: "on"
                        }]
                    }, {
                        featureType: "administrative",
                        elementType: "geometry.stroke",
                        stylers: [{
                            color: "#fefefe"
                        }, {
                            lightness: 17
                        }, {
                            weight: 1.2
                        }]
                    }, {
                        featureType: "administrative.country",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#000000"
                        }]
                    }, {
                        featureType: "administrative.country",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            color: "#ffffff"
                        }]
                    }, {
                        featureType: "administrative.locality",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#000000"
                        }]
                    }, {
                        featureType: "administrative.locality",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            color: "#ffffff"
                        }]
                    }, {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [{
                            color: "#f5f5f5"
                        }, {
                            lightness: 20
                        }]
                    }, {
                        featureType: "landscape.natural.landcover",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            lightness: "100"
                        }, {
                            gamma: "5.76"
                        }, {
                            color: "#ea0303"
                        }]
                    }, {
                        featureType: "landscape.natural.terrain",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            lightness: "-41"
                        }, {
                            saturation: "100"
                        }, {
                            gamma: "10.00"
                        }, {
                            weight: "4.94"
                        }, {
                            hue: "#ff0000"
                        }]
                    }, {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [{
                            color: "#f5f5f5"
                        }, {
                            lightness: 21
                        }]
                    }, {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [{
                            color: "#dedede"
                        }, {
                            lightness: 21
                        }]
                    }, {
                        featureType: "road.highway",
                        elementType: "geometry.fill",
                        stylers: [{
                            color: "#ffffff"
                        }, {
                            lightness: 17
                        }]
                    }, {
                        featureType: "road.highway",
                        elementType: "geometry.stroke",
                        stylers: [{
                            color: "#ffffff"
                        }, {
                            lightness: 29
                        }, {
                            weight: .2
                        }]
                    }, {
                        featureType: "road.arterial",
                        elementType: "geometry",
                        stylers: [{
                            color: "#ffffff"
                        }, {
                            lightness: 18
                        }]
                    }, {
                        featureType: "road.local",
                        elementType: "geometry",
                        stylers: [{
                            color: "#ffffff"
                        }, {
                            lightness: 16
                        }]
                    }, {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{
                            color: "#e9e9e9"
                        }, {
                            lightness: 17
                        }]
                    }, {
                        featureType: "water",
                        elementType: "geometry.fill",
                        stylers: [{
                            color: "#C9C9C9"
                        }]
                    }
                ]
            }
        };
        this.conf = $.extend(1, defaultOptions, options);

        console.debug(this.conf);
        this.init();

    }


    init(){
        console.debug('Map : init');
        this.map = new google.maps.Map(document.getElementById(this.conf.containerId), this.conf.gmap);
        this.buildAllMarkers();
        this.initMenu();
    }

    initMenu(){
        let self = this;
        $('.pageMenu > a').on('click', function(){
            $('.pageMenu > a').removeClass('active');
            $(this).addClass('active');
            self.filterContinent($(this).data('uid'));
            // on va gérer l'accessibilité, on va déplacement le label pour dire le filtre selectionné
            var $srStatus = $('.pageMenu').find('.sr-only.status');
            if($srStatus.length > 0) {
                $(this).append($srStatus)
            }
            return false;
        });
    }


    filterContinent(id){
        console.debug('Map : filterContinent : ' + id);
        let bounds = new google.maps.LatLngBounds();

        if(this.markersPerContinents[id]){
            for(let i = 0; i < this.markersPerContinents[id].length; i++){
                bounds.extend(this.markersPerContinents[id][i]);
            }
        } else {
            for(let i = 0; i < this.markers.length; i++){
                bounds.extend(this.markers[i]);
            }
        }


        var tl = new TimelineMax();
        tl.staggerTo('.mapMenuPays .mapMenuPays__list > a', 0.3, {autoAlpha: 0}, 0.05);
        tl.set('.mapMenuPays .mapMenuPays__list > a', {display: 'none'});
        tl.set('.mapMenuPays .mapMenuPays__list > a.mapMenuPays__c'+id, {display: 'block'});
        tl.staggerTo('.mapMenuPays .mapMenuPays__list > a.mapMenuPays__c'+id, 0.2, {autoAlpha: 1, onComplete: () => {
            // on va gérer l'accessibilité, foxus sur le premier element affiché
            $('.mapMenuPays .mapMenuPays__list > a.mapMenuPays__c'+id).eq(0)[0].focus();
        }}, 0.05);

        this.map.fitBounds(bounds);
    }


    setMarker(o, LatLng){

        let self = this;

        let marker = new google.maps.Marker({
            map: self.map,
            optimized: false,
            icon: {
                url: "./typo3conf/ext/bi_template/themes/default/res/img/marker.svg",
                scaledSize: new google.maps.Size(25, 30)
            },
            position: LatLng,
            title: o.title,
            myLink: o.link
        });

        google.maps.event.addListener(marker, 'click', function() {
            window.location.href = this.myLink;
        });
    }




    buildAllMarkers(){
        console.debug('Map : buildAllMarkers');
        let self = this;
        if(self.conf.activeCountry){
            self.buildMarkersCountry();
        } else if(self.conf.activeImplantation){
            self.buildMarkersImplantation();
        } else {
            self.buildMarkersContinent();
        }
    }


    buildMarkersImplantation(){
        console.debug('Map : buildMarkersImplantation');
        let self = this;
        console.debug(self);
        $.each(self.conf.datas, function(index, continent) {
            $.each(continent.pays, function(index, pays) {
                $.each(pays.imp, function(index, i) {
                    if(i.uid == self.conf.activeImplantation){
                        let coordonnees = i.gps.split(',');
                        let LatLng = new google.maps.LatLng(coordonnees[0], coordonnees[1]);
                        self.setMarker(i, LatLng);
                        self.map.panTo(LatLng);
                        self.map.setZoom(self.conf.zoom_level);
                    }
                });
            });
        });
    }


    buildMarkersCountry(){
        console.debug('Map : buildMarkersCountry');
        let bounds = new google.maps.LatLngBounds();
        let self = this;
        $.each(self.conf.datas, function(index, continent) {
            $.each(continent.pays, function(index, pays) {
                if(pays.uid == self.conf.activeCountry){
                    $.each(pays.imp, function(index, i) {
                        if(i.gps){
                            let coordonnees = i.gps.split(',');
                            let LatLng = new google.maps.LatLng(coordonnees[0], coordonnees[1]);
                            self.setMarker(i, LatLng);
                            bounds.extend(LatLng);
                        }
                    });
                }
            });
        });

        if(self.conf.map_center != '0'){
            console.debug('Map : on force le centre');
            let coordonnees = self.conf.map_center.split(',');
            self.map.panTo(new google.maps.LatLng(coordonnees[0], coordonnees[1]));
            self.map.setZoom(self.conf.zoom_level);
        } else {
            this.map.fitBounds(bounds);
        }



    }





    buildMarkersContinent(){

        let bounds = new google.maps.LatLngBounds();
        let self = this;
        self.markersPerContinents = [];
        self.markers = [];
        $.each(self.conf.datas, function(index, continent) {

            self.markersPerContinents[continent.uid] = [];

            $.each(continent.pays, function(index, pays) {
                if(pays.gps){

                    let coordonnees = pays.gps.split(',');
                    let LatLng = new google.maps.LatLng(coordonnees[0], coordonnees[1]);

                    self.setMarker(pays, LatLng);
                    self.markersPerContinents[continent.uid].push(LatLng);
                    self.markers.push(LatLng);
                    bounds.extend(LatLng);
                }
            });
        });

        this.map.fitBounds(bounds);
    }









}
